import React from 'react'
import ImageContentCard from 'molecules/surface/ImageContentCard'
import Grid from 'atoms/layout/Grid'
import Skeleton from 'atoms/feedback/Skeleton'

export type ImageContentCardListProps = {
  itemList: any[] | null
}

export default function ImageContentCardList ({ itemList }: ImageContentCardListProps) {
  if (!itemList) {
    return (
      <Grid container spacing={6}>
        { [...Array(3)].map((_, i) => (
          <Grid item xs={12} key={i}>
            <Skeleton height='20rem' variant="rect" card/>
          </Grid>
        )) }
      </Grid>
    )
  }

  return (
    <Grid container spacing={6}>
      { itemList.map((v, index) => (
        <Grid item xs={12} key={index}>
          <ImageContentCard
            url={v.eye_catching.url} title={v.title} contents={v.contents}
          />
        </Grid>
      )) }
    </Grid>
  )
}
